    
<div class = "settings-container" >
    <h2>{{ 'companySettings.title' | translate }}</h2>
    <div class = "row" style = "margin-left: 0px;">
        <h4>{{ 'companySettings.profileImage.title' | translate }}</h4>
    </div>
    <div class = "row" style = "margin-left: 0px;">
        {{ 'companySettings.profileImage.instructions' | translate }}
    </div>

    <div class="row" style="margin-left: 0px; margin-top:10px;">
        <!-- Image that will trigger the file input -->
        <img [src]="currentProfileImageUrl" alt="Profile Picture" style="cursor: pointer; width: 100px; height: 100px; border-radius: 50%;" (click)="triggerFileInput()">
        
        <!-- Hidden file input -->
        <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)">
    </div>
    <div class = "row" style = "margin-left: 0px;margin-top:15px">
        <button mat-button color="primary" style="width: 100px;" (click)="onUpload()" [disabled]="!this.selectedFile">{{ 'common.buttons.upload' | translate }}</button>
    </div>

    <h4 style = "margin-top: 60px;">{{ 'companySettings.password.title' | translate }}</h4>
    <div class = "row" style = "margin-left: 0px;">
        <mat-form-field appearance="fill" class="password-field">
            <mat-label for="currentPassword">{{ 'common.labels.currentPassword' | translate }}</mat-label>
            <input matInput type="password" id="currentPassword" [(ngModel)]="currentPassword" name="currentPassword" required>
        </mat-form-field>
    </div>
    <div class = "row" style = "margin-left: 0px;">
        <mat-form-field appearance="fill" class="password-field" style="margin-top: 15px;">
            <mat-label for="newPassword">{{ 'common.labels.newPassword' | translate }}</mat-label>
            <input matInput type="password" id="newPassword" [(ngModel)]="newPassword" name="newPassword" required>
        </mat-form-field>
    </div>
    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px;margin-top:15px;">
        <button mat-button color="primary" type="submit" (click)="changePassword()" style = "width: 150px;">{{ 'common.buttons.changePassword' | translate }}</button>
    </div>

    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px;margin-top:15px;color: red" *ngIf = "errorPass">
        {{ 'common.messages.incorrectPassword' | translate }}
    </div>

    <h4 style = "margin-top: 60px;">{{ 'companySettings.language.title' | translate }}</h4>

    <div class = "row" style = "margin-left: 0px;">
        <mat-form-field appearance="fill" class="password-field" style="margin-top: 15px;">
            <mat-label for="language">{{ 'common.labels.language' | translate }}</mat-label>
            <mat-select [(ngModel)]="language" name="language" (valueChange)="cambiarIdioma($event)" [value]="language">
                <mat-option value="es">{{ 'common.labels.spanish' | translate }}</mat-option>
                <mat-option value="en">{{ 'common.labels.english' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    

    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px;margin-top:45px;">
        <button mat-button color="primary" type="submit" (click)="logout()" style = "width: 150px;">{{ 'common.buttons.logout' | translate }}</button>
    </div>
</div>

    
